module.exports = __webpack_public_path__ + "img/back_1000.40d97a01.png";